import useT from '@hooks/useTranslation'
import SanitizedHtmlMore from '@components/html/SanitizedMore'
import offerDealerOrPrivate from './functions/offerDealerOrPrivate'

import styles from 'styles/OfferDescription.module.css'

const Description = ({
    offer: { data, description, leasing, rent, price: { rent: isRent }}}) => {

    const hasLeasing = leasing != null
        && typeof leasing === 'object'
        && Object.keys(leasing).length > 1

    if (!description && !hasLeasing && !isRent) return null

    const { dealer, priv } = offerDealerOrPrivate(data)
    const dealerText = 'Sprzedawca produktu objętego niniejszą ofertą jest'

    return (
        <div className={styles.section}>

            { isRent && rent && <div className={styles.inner}>
                <h2>{useT('Szczegóły wynajmu')}</h2>
                <br/>
                <Item data={['Miasto odbioru', rent.reception_city, '']} />
                <Item data={['Adres odbioru', rent.reception_address, '']} />
                <Item data={['Miasto zwrotu', rent.return_city, '']} />
                <Item data={['Adres zwrotu', rent.return_address, '']} />
                <Item data={['Wynajem w dni', days(rent.working_days), '']} />
                <Item data={['Godziny', hours(rent.working_hours), '']} />
                <Item data={['Wiek kierowcy', rent.driver_age, '']} />
                <Item data={['Pełny bak', yesNo(rent.full_tank), '']} />
                <Item data={['Z limitem', rent.mileage_limit, 'km']} />
                <Item data={['Z kaucją', rent.bail]} />
            </div> }

            { hasLeasing && <div className={styles.inner}>
                <h2>{useT('Możliwość leasingu')}</h2>
                <br />
                <Item data={['Początkowa opłata', leasing.leasing_initial_pay]} />
                <Item data={['Miesięczna rata', leasing.leasing_monthly_pay]} />
                <Item data={['Liczba rat', leasing.leasing_pay_count]} />
                <Item data={['Wartość wykupu', leasing.leasing_repurchase_amount]} />
            </div> }

            { description && <div className={styles.inner}>
                <h2>{useT('Opis')}</h2>
                <br/>
                <div className={styles.content}>
                    <SanitizedHtmlMore html={description} maxChars={500} />
                </div>
            </div> }

            { dealer && <p className={styles.content}><b>* {dealerText} przedsiębiorcą</b></p> }
            { priv && <p className={styles.content}><b>* {dealerText} osobą prywatną</b></p> }
        </div>
    )
}

export function Item ({ data = [] }) {
    const [name, value, currency = 'PLN'] = data
    if (value == null || value === '') return null
    return <div className={styles.item}><span className={styles.name}>{useT(name)}:</span><span className={styles.value}>{value} {currency}</span></div>
}

function days (arr) {
    return Array.isArray(arr) && arr.length > 0
        ? arr.join(' ')
        : null
}

function hours (arr) {
    if (!Array.isArray(arr) || arr.length < 1) return null
    const components = []
    if (arr[0]) components.push(`${useT('od')} ${hour(arr[0])}`)
    if (arr[1]) components.push(`${useT('do')} ${hour(arr[1])}`)
    return components.join(' ')
}

function hour (str) {
    return parseInt(str) === Number(str)
        ? `${str}.00`
        : `${str}0`
}

function yesNo (bool) {
    return typeof bool === 'boolean'
        ? bool
            ? useT('Tak')
            : useT('Nie')
        : null
}



export default Description